module.exports = __webpack_public_path__ + "static/media/success-mb-fr.45336675.png";